import { authedFetch } from '../utils/backendFetch';

export const CERTIFICATE_MAX_BYTES = 10 * 1024 * 1024;

export function certificateFileError(file) {
  if (!file || !/\.(pdf|jpe?g|png)$/i.test(file.name)) return 'Please use a PDF, JPG or PNG certificate.';
  if (!file.size || file.size > CERTIFICATE_MAX_BYTES) return 'Upload a non-empty certificate smaller than 10MB.';
  return '';
}

export async function requestCertificatePrefill(file, registry, signal) {
  const invalid = certificateFileError(file);
  if (invalid) throw new Error(invalid);
  const body = new FormData();
  body.append('file', file);
  body.append('registry', registry);
  let response;
  try {
    response = await authedFetch(`${process.env.REACT_APP_MAIN_BACKEND_URL}/scribe/certificate-prefill`, {
      method: 'POST', body, signal,
    });
  } catch (error) {
    if (error.name === 'AbortError') throw error;
    throw new Error('Could not read the certificate. Try again or enter the details manually.');
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    // Do not display raw gateway/provider errors or echoed document content.
    const messages = {
      400: 'Check the selected registry and use a PDF, JPG or PNG certificate smaller than 10MB (PDF: up to 5 pages).',
      401: 'Your session has expired. Please sign in again.',
      422: 'The certificate could not be read or does not match the selected registry. Check the document or enter the details manually.',
      503: 'Certificate extraction is unavailable. You can enter the details manually.',
      504: 'Reading the certificate timed out. Try again or enter the details manually.',
    };
    throw new Error(messages[response.status] || 'Could not read the certificate. Try again or enter the details manually.');
  }
  if (data.registry !== registry || !data.fields || typeof data.fields !== 'object') {
    throw new Error('The certificate details could not be confirmed. Please enter them manually.');
  }
  return data.fields;
}
